// extracted by mini-css-extract-plugin
export default {"image-radius":"odIsR_image-radius"};